export default __webpack_public_path__ + "static/media/Gallery4.eb05a5b6.jpeg";